<template>
  <div class="not-found">
    <h1>404 - صفحه پیدا نشد</h1>
    <p>صفحه‌ای که به دنبال آن هستید وجود ندارد.</p>
    <router-link class="btn btn-primary" to="/">بازگشت به صفحه اصلی</router-link>
  </div>
</template>

<script setup>
// نیازی به کد خاصی نیست
</script>

<style scoped>
.not-found {
  text-align: center;
  margin-top: 100px;
}
</style>
